(() => {
  const slugify = (value) =>
    value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');

  const buildTableOfContents = (root) => {
    const content = root.querySelector('[data-ll-article-content]');
    const toc = root.querySelector('[data-ll-toc]');
    const list = root.querySelector('[data-ll-toc-list]');

    if (!content || !toc || !list) return;

    const headings = [...content.querySelectorAll('h2, h3')].filter(
      (heading) => heading.textContent.trim().length > 0
    );

    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }

    const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));

    headings.forEach((heading, index) => {
      let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
      const baseId = id;
      let duplicateIndex = 2;

      while (usedIds.has(id) && heading.id !== id) {
        id = `${baseId}-${duplicateIndex}`;
        duplicateIndex += 1;
      }

      heading.id = id;
      usedIds.add(id);

      const item = document.createElement('li');
      item.className = `ll-toc__item ll-toc__item--${heading.tagName.toLowerCase()}`;

      const link = document.createElement('a');
      link.className = 'll-toc__link';
      link.href = `#${id}`;
      link.textContent = heading.textContent;

      item.appendChild(link);
      list.appendChild(item);
    });

    toc.hidden = false;

    if (!('IntersectionObserver' in window)) return;

    const links = [...list.querySelectorAll('a')];
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

        if (!visible) return;

        links.forEach((link) => {
          if (link.hash === `#${visible.target.id}`) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      },
      { rootMargin: '-20% 0px -65% 0px', threshold: 0 }
    );

    headings.forEach((heading) => observer.observe(heading));
  };

  const activateCopyButtons = (root) => {
    root.querySelectorAll('[data-ll-copy-link]').forEach((button) => {
      button.addEventListener('click', async () => {
        const originalLabel = button.textContent;
        const successLabel = button.dataset.successLabel || 'Lien copié';

        try {
          await navigator.clipboard.writeText(window.location.href);
          button.textContent = successLabel;
          window.setTimeout(() => {
            button.textContent = originalLabel;
          }, 1800);
        } catch (error) {
          window.prompt('Copiez ce lien :', window.location.href);
        }
      });
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-ll-article]').forEach((root) => {
      if (root.dataset.llInitialized === 'true') return;
      root.dataset.llInitialized = 'true';
      buildTableOfContents(root);
      activateCopyButtons(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
